import { H1 } from '../../components/elements/Text';
import Navbar from '../../components/Navbar';
import PageWithAsyncData from '../../components/PageWithAsyncData';
import { useParams } from 'react-router-dom';
import { useGetCompany } from '../../hooks/use-hydra/admin';
import day from 'dayjs';
import utc from 'dayjs/plugin/utc';
import CompanyPageWrapper from '../../components/Admin/CompanyPageWrapper';
import { COMPANY_PAGES } from '../../components/Admin/CompanySideNavigation';
import { useGetExerciseSubmissions } from '../../hooks/use-hydra/admin';
import ReplyToSOSQuestion from '../../components/Admin/ReplyToSOSQuestion';
import { ROUTES } from '../../routing';

day.extend(utc);

const NavbarWithBreadcrumbs = ({
  name,
  companyId,
}: {
  name?: string;
  companyId: string;
}) => (
  <Navbar
    breadCrumbs={[
      {
        label: 'Home',
        url: ROUTES.HOME.getPath(),
      },
      {
        label: 'Teams',
        url: ROUTES.ADMIN.COMPANIES.getPath(),
      },
      {
        label: name || 'Company',
        url: ROUTES.ADMIN.COMPANY.getPath({ companyId }),
      },
      {
        label: 'SOS Questions',
        url: ROUTES.ADMIN.SOS_QUESTIONS.getPath({ companyId }),
      },
      {
        label: 'Reply',
        url: null,
      },
    ]}
  />
);

export default function ReplyToSOSQuestionPage() {
  const { id, questionId, submissionId } =
    useParams<{
      id: string;
      questionId: string;
      submissionId: string;
    }>();
  const {
    data,
    isLoading: isCompanyLoading,
    error,
    refetch,
  } = useGetCompany(parseInt(id));
  const { data: submissionsData, isLoading: isSubmissionsLoading } =
    useGetExerciseSubmissions(parseInt(id));

  const headerText = `Reply to SOS Question`;

  const submission = submissionsData?.submissions.find(
    (s) =>
      s.submission.id === parseInt(submissionId) &&
      s.question.id === parseInt(questionId)
  );

  return (
    <PageWithAsyncData
      isLoading={isSubmissionsLoading || isCompanyLoading}
      error={error}
      retry={refetch}
      noScroll
    >
      <NavbarWithBreadcrumbs name={data?.name} companyId={id} />
      <CompanyPageWrapper
        currentPage={COMPANY_PAGES.SUBMISSIONS}
        contentStyle={{ width: '100%', overflowX: 'auto', maxWidth: '100%' }}
      >
        <H1>{headerText}</H1>
        {submission && <ReplyToSOSQuestion submission={submission} />}
      </CompanyPageWrapper>
    </PageWithAsyncData>
  );
}
